import { FlaskConical } from "lucide-react";
import { isTestEnv } from "../config/env";

/**
 * Environment-level TEST banner.
 *
 * Renders a sticky yellow strip at the top of the page when the bundle was
 * built against a staging backend URL. Returns null in production so there
 * is no reserved height, no empty element, no DOM footprint.
 *
 * Mount this as the first child of a page wrapper. It does not affect
 * scroll containers — `sticky top-0 z-50` keeps it visible if a page-level
 * scroll container appears (e.g. multi-step wizard wrapping its own
 * scrollable region).
 *
 * Brief 13 scope: mounted on /invoice-request, /payment-request, and
 * /third-party-invoices only. NOT mounted in AppLayout — that's a
 * different decision and out of scope.
 *
 * No firm-specific strings — copy is generic and CaseMinder-agnostic.
 */
export default function TestEnvBanner() {
  if (!isTestEnv()) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      data-testid="test-env-banner"
      className="sticky top-0 z-50 w-full bg-status-amber-dim border-b border-amber-300 px-4 py-2 flex items-center justify-center gap-2 text-status-amber font-semibold text-sm"
    >
      <FlaskConical className="w-4 h-4" aria-hidden="true" />
      <span>TEST ENVIRONMENT - changes here do not affect production</span>
    </div>
  );
}
